/* eslint-disable no-restricted-globals */

/* -----------------------------
    VALIDATORS
--------------------------------*/

// whiteSpaceTrimmedRegex /^(?=[A-Za-z0-9])([A-Za-z0-9\s]*)(?<=[A-Za-z0-9])$/
export const required = value =>
  value && value.trim() ? undefined : 'Required';

export const mustBeNumber = value =>
  isNaN(value) ? 'Must be a number' : undefined;

export const minValue = min => value =>
  !isNaN(value) || value >= min ? undefined : `Should be at least ${min}`;

export const maxValue = max => value => {
  let num = value;
  if (typeof value === 'string') {
    num = parseFloat(value.replace(/,/g, ''));
  }
  return isNaN(num) || num <= max ? undefined : `Should be no more than ${max}`;
};
export const minValueDefault = min => value =>
  !isNaN(value) || value >= min ? undefined : `The default of ${min} will be set. `;

export const maxLength = max => value =>
  !value ? undefined : value.length <= max ? undefined : `Please use no more than ${max} characters. `;

export const isEmail = value => {
  // debugger; // eslint-disable-line
  const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(value) ? undefined : 'Must be a valid email';
};

// original 

/* original */
/*

export const isPhoneNumber = value => {
  if (!value) return undefined;
  const phoneNumberRegex = /\d{3}-\d{3}-\d{4}/;
  const unformattedPhoneNumberRegex = /\d{10}/;
  return phoneNumberRegex.test(value) || unformattedPhoneNumberRegex.test(value)
    ? undefined
    : 'Must be a number in the format xxx-xxx-xxxx';
};

*/

export const isPhoneNumber = input => {
  if (input && typeof input === 'string') {
    const cleaned = input
      .replace(/\(/g, '')
      .replace(/\)/g, '')
      .replace(/-/g, '')
      .replace(/ /g, '')
      .replace(/_/g, '');
    return cleaned.length === 10
      ? undefined
      : 'Must be a number in the format (xxx) xxx-xxxx';
  }
  return undefined;
};



/*
export const isPhoneNumber = value => {
  const phoneNumberRegex = /\d{3}-\d{3}-\d{4}/;
  const unformattedPhoneNumberRegex = /\d{10}/;  
  return (((!value) || phoneNumberRegex.test(value) || unformattedPhoneNumberRegex.test(value))?undefined:'Must be a number in the format xxx-xxx-xxxx');
};

/*
export const isPhoneNumber = value => {
  const phoneNo = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  let isValidPhone;
    if(value === undefined || value.match(phoneNo)) {
      isValidPhone = true;      
    } else {	   
      isValidPhone = false; 
    } 
   return isValidPhone?undefined:'Must be a number in the format xxx-xxx-xxxx';
};
*/

export const isUSZipCode = value => {
  const zipCodeRegex = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
  return zipCodeRegex.test(value) ? undefined : 'Must be a valid US zip code';
};

export const isCanadianZipCode = value => {
  const zipCodeRegex = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i;
  return zipCodeRegex.test(value)
    ? undefined
    : 'Must be a valid Canadian zip code';
};

export const isInvalidUSorCANZipCode = (value, country) => {
  console.log(country)
  if (country === "USA") return isUSZipCode(value)
  if (country === "CAN") return isCanadianZipCode(value)
  return 'Invalid Country'
}

const nationalStockNumberRegex = /(^\d{13}$)|(^\d{4}-\d{2}-\d{3}-\d{4}$)/;
const nsnUnformattedRegex = /(^\d{13}$)/;

const NIINRegex = /^\d{9}$|(^\d{2}-\d{3}-\d{4}$)/;
const niinUnformattedRegex = /^\d{9}$/;

export const isNationalStockNumber = value =>
  nationalStockNumberRegex.test(value)
    ? undefined
    : 'Must be a valid national stock number formatted as xxxx-xx-xxx-xxxx';

export const isNationalItemIdentificationNumber = value =>
  NIINRegex.test(value) ? undefined : 'Must be a valid Item ID Number';

export const isNSNorNIIN = value => {
  if (!value || value.length === 0) return undefined;
  if (NIINRegex.test(value) || nationalStockNumberRegex.test(value))
    return undefined;
  return 'Must be formatted as NIIN or NSN';
};

export const isUnformattedNSNorNIIN = value => {
  if (!value || value.length === 0) return undefined;
  const unformattedValue = (value.split('-').join(''))

  if (niinUnformattedRegex.test(unformattedValue) || nsnUnformattedRegex.test(unformattedValue))
    return undefined;
  return 'Must be a 9 or 13 digit NIIN or NSN';
};

export const isCageCode = value => {
  const cageCodeRegex = /^[A-Za-z0-9]{5}$/;
  return cageCodeRegex.test(value)
    ? undefined
    : 'Must be a valid 5-digit cage code';
};

export const isCageEditable = cage => {
  let isCageE;
  if (cage !== undefined) {
    isCageE = cage.startsWith('O');
  }
  return !isCageE;
}

export const isWsdcSize = value => {
  let _wsdcSize;
  if (value === undefined || value.length === 2 || value.length === 3) {
    _wsdcSize = true;
  } else {
    _wsdcSize = false;
  }
  return !_wsdcSize;
}

/* -----------------------------
    COMPOSE VALIDATORS
--------------------------------*/
export const composeValidators = (...validators) => value =>
  validators.reduce((error, validator) => error || validator(value), undefined);

export const composeValidatorsForNonRequired = (...validators) => value =>
  value
    ? validators.reduce(
      (error, validator) => error || validator(value),
      undefined,
    )
    : undefined;

// Use Case: Test the value of a field where the input is not required against multiple validators
export const composeNonRequiredValidatorsForEitherOr = (...validators) => (
  value,
  error,
) => {
  const arr = [];
  if (!value) return undefined;

  validators.map(validator => arr.push(validator(value)));
  return arr.includes(undefined) ? undefined : error;
};

export const isGovernmentEmail = value => {
  if (!value) return undefined;
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.mil$/;
  return emailRegex.test(value) ? undefined : 'Must be a valid .mil email address';
};

// Validator to check for at least first and last name
export const hasFirstAndLastName = value => {
  if (!value) return 'User must at least have a first and last name';
  // Split by whitespace, filter out empty strings
  const parts = value.trim().split(/\s+/).filter(Boolean);
  return parts.length >= 2 ? undefined : 'User must at least have a first and last name';
};



// WEBPACK FOOTER //
// ./src/utils/validationUtils.js